export default "/images/vendor/vue-hotel-datepicker/dist/ic-arrow-right-datepicker.regular.99ab0620.svg?38d376a780635ae10e835c1c1a66cac8";